import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";

// test comment
// project import
import router from "./routes";
import ThemeCustomization from "./themes";

import Locales from "./components/Locales";
import ScrollTop from "./components/ScrollTop";
import Snackbar from "./components/@extended/Snackbar";
import Notistack from "./components/third-party/Notistack";
import { SelectedUnitProvider } from "./contexts/SelectedUnitContext";
import { JWTProvider as AuthProvider } from "./contexts/JWTContext";
import { TokenProvider } from "./api/TokenContext";
import VersionDisplay from "./components/VersionDisplay";

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

const App = () => {
  useEffect(() => {
    sessionStorage.removeItem("chunk-load-reloaded");
  }, []);

  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <SelectedUnitProvider>
              <TokenProvider>
                <Notistack>
                  <RouterProvider router={router} />
                  <VersionDisplay />
                  <Snackbar />
                </Notistack>
              </TokenProvider>
            </SelectedUnitProvider>
          </AuthProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
};

export default App;
